import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { StateHelperService } from '@Core/services/proprietary/state-helper.service';
import { PageObjectModule } from '../page/page-object.module';
import { TaskObjectService } from './task-object.service';
import { TaskObjectState } from './task-object.state';

@NgModule({
    imports: [
        NgxsModule.forFeature([TaskObjectState]),
        PageObjectModule
    ],
    providers: [TaskObjectService, StateHelperService]
})
export class TaskObjectModule { }
